<template>
    <div>
        <a href="#" @click="togglePlay()">
            <icon v-if="isPlaying" icon="pause"/>
            <icon v-else icon="play"/>

        </a>
    </div>
</template>

<script>

    import Icon from "../ui/Icon";

    export default {
        name: 'PlayPauseBtn',
        props: ['me', 'post'],
        data() {
            return {
                isPlaying: false
            }
        },
        mounted() {
            this.$bus.$on('player.close', ()=>{
                this.isPlaying = false;
                this.$store.commit('player/setPause');
            });
            setTimeout(()=>{
                this.isPlaying = !this.me.paused;
                this.me.onclick = this.togglePlay;
                this.me.onplay = (e)=>{this.isPlaying=true;this.$store.commit('player/setPlay');};
                this.me.onpause = (e)=>{this.isPlaying=false;this.$store.commit('player/setPause');};
                this.me.onended = (e)=>{
                    this.isPlaying=false;
                    this.$store.commit('player/setPause');
                    this.$bus.$emit('playNextVideo', this.post)
                };
                this.onerror = (e)=>{
                    this.$bus.$emit('error', "Oh... there is something wrong with this video... I will skip it!");
                    setTimeout(()=>{
                        if(this.isPlaying) {
                            this.$bus.$emit('playNextVideo', this.post);
                        }
                    }, 3000);
                };
                this.me.onloadstart  = (e)=>{
                    this.isPlaying = !this.me.paused;
                    if(this.isPlaying){
                        this.$store.commit('player/setPlay');
                    } else {
                        this.$store.commit('player/setPause');
                    }
                };
            },5);

        },

        methods: {
            togglePlay(){
                if(this.isPlaying){
                    this.me.pause();
                } else {
                    this.me.play();
                }

            }
        },
        components:{
            Icon
        }
    }
</script>

<style lang="sass">

</style>



// WEBPACK FOOTER //
// src/components/player/PlayBtn.vue